module.exports = __webpack_public_path__ + "static/media/nv-coconut.42cb06a1.jpg";